exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".end-assignment-modal-body {\n    width: 510px;\n}\n.select-title {\n    font-weight: 600;\n    line-height: 24px;\n}\n.request-container {\n    margin-bottom: 16px;\n    width: 100%;\n}\n", ""]);

// exports
